
let denomIconDirective = function ($templateCache, DenominationService) {
    'ngInject';
    return {
        restrict: 'E',
        scope: {
            denomId: '=',
            label: '@',
            iconSize: '@'
        },
        template: `
            <span class="denom-icon-wrapper" 
                  uib-popover-template="'denomPopover.html'" 
                  popover-trigger="'mouseenter'" 
                  popover-is-open="isOpen"
                  ng-click="isOpen = false"
                  popover-append-to-body="true" 
                  popover-placement="auto top" 
                  popover-class="denom-icon-popover-window">
                <span ng-if="label" ng-style="iconSize ? {'font-size': iconSize + 'px'} : {}">{{label}}</span>
                <img ng-if="!label" ng-src="assets/images/{{denomId == '1' ? '$1c' : denomId}}.png" class="denom-icon-sm" ng-style="iconSize ? {'width': iconSize + 'px'} : {}" />
            </span>
        `,
        link: function (scope) {
            if (!$templateCache.get('denomPopover.html')) {
                $templateCache.put('denomPopover.html', `
                    <div class="denom-icon-popover-content">
                        <img ng-src="assets/images/{{denomId == '1' ? '$1c' : denomId}}.png" class="denom-icon-lg" />
                        <div class="denom-icon-label">{{denomName || denomId}}</div>
                    </div>
                `);
            }
            scope.denomName = '';
            scope.$watch('denomId', function(newVal) {
                if(newVal) {
                    DenominationService.getName(newVal).then(name => {
                        scope.denomName = name;
                    });
                }
            });
        }
    };
};

export default denomIconDirective;



// WEBPACK FOOTER //
// ./client/app/common/denom-icon/denom-icon.directive.js